import React from "react";
import "../../../fonts/font.css";

import feeIcon1 from "../../../images/fee_icon_1.png";
import feeIcon2 from "../../../images/fee_icon_2.png";
import feeIcon3 from "../../../images/fee_icon_3.png";

import {
  SolutionContentsWrapper,
  LineWrapper,
  Title,
  TitleIcon,
  Cost,
  IncreaseBadges,
  DecreaseBadges,
  NewBadges,
  SameBadges,
} from "../solution/solution_components.js";

export function NumSolution({ src, iconHeight, iconWidth }) {
  var totalNum = sessionStorage.getItem("spacenum");
  var suggDayPass = Math.floor(totalNum * 0.1);
  var suggMonthPass = Math.floor(totalNum * 0.21);
  var suggTimePass = Math.floor(totalNum * 0.7);

  var dayPass = sessionStorage.getItem("dayPassNum");
  var monthPass = sessionStorage.getItem("monthPassNum");
  var timePass = sessionStorage.getItem("timePassFee");

  return (
    <SolutionContentsWrapper>
      <LineWrapper>
        <TitleIcon src={feeIcon1} iconHeight="15" iconWidth="15" />
        <Title>시간권</Title>
        <Cost> {suggTimePass}대 </Cost>
        {timePass !== "" ? ( // 데이터 입력이 없었으면
          timePass==suggTimePass ? ( // 동일한 값이면
            <SameBadges type="대수" /> // 동결 배지
          ) : timePass < suggTimePass ? ( // 증가한 값이면
            <IncreaseBadges
              type="대수"
              increaseNum={Math.floor((suggTimePass / timePass - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="대수" decreaseNum={Math.floor((timePass / suggTimePass - 1) * 100)} /> //감소배지
          )
        ) : (timePass == "0" ?
        (<NewBadges /> // 신규 배지
      ) : (<NewBadges />))}
      </LineWrapper>
      <LineWrapper>
        <TitleIcon src={feeIcon3} iconHeight="15" iconWidth="25" />
        <Title>일 정기권</Title>
        <Cost marginLeft="90"> {suggDayPass}대 </Cost>
        {dayPass !== "" ? ( // 데이터 입력이 없었으면
          dayPass==suggDayPass ? ( // 동일한 값이면
            <SameBadges type="대수" /> // 동결 배지
          ) : dayPass < suggDayPass ? ( // 증가한 값이면
            <IncreaseBadges
              type="대수"
              increaseNum={Math.floor((suggDayPass / dayPass - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="대수" decreaseNum={Math.floor((dayPass / suggDayPass - 1) * 100)} /> //감소배지
          )
        ) : (dayPass == "0" ?
        (<NewBadges /> // 신규 배지
      ) : (<NewBadges />))}
      </LineWrapper>
      <LineWrapper>
        <TitleIcon src={feeIcon2} iconHeight="15" iconWidth="15" />
        <Title>월 정기권</Title>
        <Cost> {suggMonthPass}대 </Cost>
        {monthPass !== "" ? ( // 데이터 입력이 없었으면
          monthPass==suggMonthPass ? ( // 동일한 값이면
            <SameBadges type="대수" /> // 동결 배지
          ) : monthPass < suggMonthPass ? ( // 증가한 값이면
            <IncreaseBadges
              type="대수"
              increaseNum={Math.floor((suggMonthPass / monthPass - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="대수" decreaseNum={Math.floor((monthPass / suggMonthPass - 1) * 100)} /> //감소배지
          )
        ) : (monthPass == "0" ?
        (<NewBadges /> // 신규 배지
      ) : (<NewBadges />))}
      </LineWrapper>

    </SolutionContentsWrapper>
  );
}
